import { render, staticRenderFns } from "./backIcon.vue?vue&type=template&id=3cfa5332&scoped=true"
import script from "./backIcon.vue?vue&type=script&lang=js"
export * from "./backIcon.vue?vue&type=script&lang=js"
import style0 from "./backIcon.vue?vue&type=style&index=0&id=3cfa5332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa5332",
  null
  
)

export default component.exports